export const categories = [
  {
    name: 'Scarpe',
    nameEn: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Single%20pair%20of%20cream%20white%20minimalist%20sneakers%20with%20subtle%20design%20details%20on%20light%20beige%20textured%20surface%2C%20soft%20diffused%20daylight%2C%20clean%20product%20photography%2C%20warm%20neutral%20tones%2C%20elegant%20isolated%20composition%2C%20simple%20sophisticated%20aesthetic&width=400&height=300&seq=cat-shoes&orientation=landscape',
  },
  {
    name: 'Felpe',
    nameEn: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20cream%20oversized%20hoodie%20neatly%20folded%20on%20light%20linen%20fabric%20surface%2C%20soft%20morning%20sunlight%2C%20minimal%20product%20photography%2C%20warm%20beige%20and%20ivory%20tones%2C%20clean%20calm%20composition%2C%20high%20detail%20fabric%20texture%2C%20comfortable%20casual%20aesthetic&width=400&height=300&seq=cat-hoodies&orientation=landscape',
  },
  {
    name: 'T-Shirt',
    nameEn: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20white%20tshirt%20laid%20flat%20on%20natural%20textured%20linen%20background%2C%20soft%20diffused%20daylight%2C%20minimal%20product%20photography%2C%20warm%20cream%20tones%2C%20elegant%20simple%20composition%2C%20high%20detail%20fabric%20weave%20texture%2C%20sophisticated%20casual%20look&width=400&height=300&seq=cat-tshirts&orientation=landscape',
  },
  {
    name: 'Giacche',
    nameEn: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-sun-line',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20lightweight%20beige%20bomber%20jacket%20on%20minimalist%20wooden%20hanger%20against%20soft%20cream%20wall%20background%2C%20natural%20window%20light%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20tones%2C%20clean%20sophisticated%20composition%2C%20high%20detail&width=400&height=300&seq=cat-jackets&orientation=landscape',
  },
  {
    name: 'Pantaloni',
    nameEn: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20beige%20linen%20trousers%20on%20light%20cream%20fabric%20surface%2C%20soft%20natural%20window%20light%2C%20minimal%20product%20photography%2C%20warm%20neutral%20earth%20tones%2C%20clean%20elegant%20composition%2C%20high%20detail%20fabric%20texture%2C%20sophisticated%20casual%20style&width=400&height=300&seq=cat-pants&orientation=landscape',
  },
  {
    name: 'Cappelli',
    nameEn: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-base-station-line',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20cream%20baseball%20cap%20placed%20on%20light%20oak%20wooden%20surface%2C%20soft%20natural%20daylight%2C%20minimal%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20simple%20composition%2C%20high%20detail%20fabric%20texture%2C%20modern%20casual%20aesthetic&width=400&height=300&seq=cat-headwear&orientation=landscape',
  },
  {
    name: 'Set',
    nameEn: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Coordinated%20set%20of%20folded%20cream%20beige%20casual%20clothing%20pieces%20on%20light%20linen%20surface%2C%20soft%20natural%20window%20light%2C%20minimal%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20organized%20composition%2C%20modern%20matching%20outfit%20aesthetic&width=400&height=300&seq=cat-sets&orientation=landscape',
  },
  {
    name: 'Intimo',
    nameEn: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-user-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20pieces%20neatly%20arranged%20on%20light%20beige%20linen%20fabric%2C%20soft%20diffused%20natural%20light%2C%20minimal%20clean%20product%20photography%2C%20warm%20cream%20tones%2C%20subtle%20elegant%20composition%2C%20high%20detail%20fabric%20texture&width=400&height=300&seq=cat-underwear&orientation=landscape',
  },
  {
    name: 'Maglie Sportive',
    nameEn: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-basketball-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20sports%20jersey%20in%20cream%20white%20tone%20laid%20flat%20on%20light%20textured%20surface%2C%20soft%20natural%20daylight%2C%20minimal%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20athletic%20aesthetic%2C%20high%20detail%20fabric%20mesh%20texture%2C%20modern%20sporty%20composition&width=400&height=300&seq=cat-jersey&orientation=landscape',
  },
  {
    name: 'Accessori',
    nameEn: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20arrangement%20of%20sunglasses%20watch%20and%20leather%20bracelet%20on%20light%20marble%20surface%2C%20soft%20natural%20light%2C%20lifestyle%20product%20photography%2C%20warm%20beige%20cream%20tones%2C%20sophisticated%20clean%20composition%2C%20high%20detail%20craftsmanship&width=400&height=300&seq=cat-accessories&orientation=landscape',
  },
  {
    name: 'Borse',
    nameEn: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20tote%20bag%20in%20warm%20cognac%20tone%20on%20light%20oak%20wooden%20surface%2C%20soft%20window%20light%2C%20minimal%20product%20photography%2C%20warm%20earthy%20neutral%20palette%2C%20elegant%20simple%20composition%2C%20high%20detail%20leather%20grain%20texture&width=400&height=300&seq=cat-bags&orientation=landscape',
  },
  {
    name: 'Cinture',
    nameEn: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20leather%20belt%20in%20warm%20brown%20tone%20coiled%20on%20light%20cream%20surface%2C%20soft%20natural%20daylight%2C%20minimal%20product%20photography%2C%20warm%20neutral%20tones%2C%20sophisticated%20simple%20composition%2C%20high%20detail%20leather%20texture%20and%20metal%20buckle&width=400&height=300&seq=cat-belts&orientation=landscape',
  },
  {
    name: 'Profumi',
    nameEn: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20on%20light%20marble%20surface%2C%20soft%20natural%20window%20light%20creating%20gentle%20reflections%2C%20minimal%20luxury%20product%20photography%2C%20warm%20golden%20cream%20tones%2C%20sophisticated%20refined%20composition&width=400&height=300&seq=cat-perfumes&orientation=landscape',
  },
  {
    name: 'Altro',
    nameEn: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20lifestyle%20accessories%20including%20small%20gadgets%20and%20decor%20items%20on%20light%20textured%20surface%2C%20soft%20natural%20daylight%2C%20minimal%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20eclectic%20composition%2C%20modern%20everyday%20essentials&width=400&height=300&seq=cat-other&orientation=landscape',
  },
];

export const faqData = [
  {
    q: 'Cos\'&egrave; Itaobuy Spreadsheet?',
    a: 'Itaobuy Spreadsheet &egrave; uno strumento organizzato che permette agli utenti italiani di raccogliere, analizzare e confrontare prodotti provenienti da marketplace internazionali. Grazie a categorie ordinate, informazioni dettagliate e sistemi di confronto, gli utenti possono trovare rapidamente prodotti interessanti evitando ricerche lunghe e complicate.',
  },
  {
    q: 'Itaobuy Spreadsheet &egrave; gratuito?',
    a: 'S&igrave;, Itaobuy Spreadsheet offre una versione gratuita con accesso a numerose categorie di prodotti e funzionalit&agrave; di base. Per funzionalit&agrave; avanzate e liste personalizzate, sono disponibili opzioni premium con vantaggi aggiuntivi per gli utenti pi&ugrave; esigenti.',
  },
  {
    q: 'Come posso trovare i prodotti migliori con Itaobuy Spreadsheet?',
    a: 'Puoi navigare tra le 14 categorie disponibili, confrontare prezzi e recensioni direttamente nello spreadsheet, e utilizzare i filtri per ordinare per popolarit&agrave;, prezzo e valutazione. Ogni categoria &egrave; aggiornata regolarmente con nuovi prodotti selezionati dal nostro team.',
  },
  {
    q: 'Itaobuy Spreadsheet &egrave; sicuro da usare?',
    a: 'Assolutamente s&igrave;. Itaobuy Spreadsheet non richiede dati personali sensibili e funge esclusivamente da strumento di ricerca e confronto. Gli acquisti vengono effettuati tramite la piattaforma principale con sistemi di pagamento protetti e verifica dei venditori.',
  },
  {
    q: 'Con quale frequenza viene aggiornato Itaobuy Spreadsheet?',
    a: 'Lo spreadsheet viene aggiornato settimanalmente con nuovi prodotti, categorie e recensioni. Il nostro team monitora costantemente le tendenze del mercato per offrirti sempre le migliori opportunit&agrave; di acquisto nel 2026.',
  },
  {
    q: 'Posso usare Itaobuy Spreadsheet su dispositivi mobili?',
    a: 'S&igrave;, Itaobuy Spreadsheet &egrave; completamente ottimizzato per la visualizzazione su smartphone e tablet. Puoi accedere alle categorie, confrontare prodotti e consultare le guide direttamente dal tuo dispositivo mobile in qualsiasi momento.',
  },
  {
    q: 'Quali tipi di prodotti posso trovare su Itaobuy Spreadsheet?',
    a: 'Troverai un\'ampia gamma di prodotti: scarpe e sneakers, abbigliamento streetwear, felpe e t-shirt, giacche, pantaloni e shorts, cappelli e accessori, borse e cinture, profumi, set completi, maglie sportive e molto altro ancora.',
  },
  {
    q: 'Itaobuy Spreadsheet offre spedizioni in Italia?',
    a: 'S&igrave;, i prodotti presenti nello spreadsheet provengono da marketplace che offrono spedizioni internazionali in Italia. Puoi verificare tempi e costi di spedizione direttamente sulla piattaforma principale prima di completare l\'acquisto.',
  },
  {
    q: 'Come si confronta Itaobuy Spreadsheet con la ricerca manuale?',
    a: 'Rispetto alla ricerca manuale, Itaobuy Spreadsheet ti fa risparmiare ore di tempo offrendoti prodotti gi&agrave; organizzati per categoria, prezzi confrontati e recensioni verificate. La precisione &egrave; molto pi&ugrave; alta e il risparmio economico &egrave; significativo.',
  },
  {
    q: 'Ci sono alternative a Itaobuy Spreadsheet?',
    a: 'Esistono altri strumenti di product research, ma Itaobuy Spreadsheet si distingue per l\'organizzazione in lingua italiana, le categorie specificamente pensate per il mercato italiano e gli aggiornamenti costanti. &Egrave; la soluzione pi&ugrave; completa per chi acquista dall\'Italia.',
  },
  {
    q: 'Devo registrarmi per usare Itaobuy Spreadsheet?',
    a: 'No, non &egrave; necessaria alcuna registrazione per accedere alle categorie e alle guide di Itaobuy Spreadsheet. Puoi iniziare subito a esplorare i prodotti e le recensioni senza creare un account.',
  },
  {
    q: 'Come posso essere sicuro della qualit&agrave; dei prodotti?',
    a: 'Ogni prodotto presente nello spreadsheet include foto reali, recensioni verificate e valutazioni dei venditori. Ti consigliamo di leggere sempre le recensioni e controllare le foto prima dell\'acquisto per garantirti la massima qualit&agrave;.',
  },
  {
    q: 'Posso suggerire nuove categorie per Itaobuy Spreadsheet?',
    a: 'Certamente! Siamo sempre aperti ai suggerimenti della nostra community italiana. Se hai idee per nuove categorie o prodotti che vorresti vedere nello spreadsheet, non esitare a contattarci tramite la piattaforma principale.',
  },
  {
    q: 'Itaobuy Spreadsheet funziona anche per acquisti all\'ingrosso?',
    a: 'S&igrave;, molte categorie includono opzioni per acquisti all\'ingrosso con prezzi scontati. Puoi utilizzare lo spreadsheet per confrontare fornitori e trovare le migliori offerte per quantit&agrave; maggiori.',
  },
  {
    q: 'Quali sono i metodi di pagamento accettati?',
    a: 'I pagamenti vengono elaborati tramite la piattaforma principale, che supporta molteplici metodi tra cui carte di credito, PayPal e bonifici bancari. Tutti i sistemi di pagamento sono protetti e crittografati per la massima sicurezza.',
  },
];